import React from 'react'
import Video from '../Video'
import styled from 'styled-components'
const ImagesThreeUpWrapper = styled.div`
    .image-3-grid {
        display: grid;
        grid-template-columns: [image-1] 4fr [image-2] 4fr [image-3] 4fr;
        column-gap: 1rem;
    }
    .image-3-1 {
        grid-area: image-1;
    }
    .image-3-2 {
        grid-area: image-2;
    }
    .image-3-3 {
        grid-area: image-3;
    }
`



const VideoPlayer23 = ({videoURL1, altText1, poster1, videoURL2, altText2, poster2, videoURL3, altText3, poster3}) => {
    return (
        <ImagesThreeUpWrapper className="row-component">
            <div className="image-3-grid">
                <div className="image-3-1">
                    { <Video videoURL = {videoURL1} altText={altText1} poster={poster1} /> }
                </div>
                <div className="image-3-2">
                    { <Video videoURL = {videoURL2} altText={altText2} poster={poster2} /> }
                </div>
                <div className="image-3-3">
                    { <Video videoURL = {videoURL3} altText={altText3} poster={poster3} /> }
                </div>
            </div>
        </ImagesThreeUpWrapper>
    )
}

export default VideoPlayer23